import { SVGProps } from 'react'

export const GlobeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 12.5C22 18.0229 17.5228 22.5 12 22.5M22 12.5C22 6.97716 17.5228 2.5 12 2.5M22 12.5C22 10.2909 17.5228 8.5 12 8.5C6.47715 8.5 2 10.2909 2 12.5M22 12.5C22 14.7091 17.5228 16.5 12 16.5C6.47715 16.5 2 14.7091 2 12.5M12 22.5C6.47715 22.5 2 18.0228 2 12.5M12 22.5C14.2091 22.5 16 18.0229 16 12.5C16 6.97716 14.2091 2.5 12 2.5M12 22.5C9.79086 22.5 8 18.0229 8 12.5C8 6.97715 9.79086 2.5 12 2.5M2 12.5C2 6.97715 6.47715 2.5 12 2.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
